import React from 'react';
import { Box } from '@mui/material';

// Error boundary for lazy loading failures
export default class LazyLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, retryCount: 0 };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Lazy loading error:', error, errorInfo);
  }

  handleRetry = () => {
    const newRetryCount = this.state.retryCount + 1;
    
    // If multiple retries failed (3+ attempts), do full page reload
    if (newRetryCount >= 3) {
      window.location.reload();
      return;
    }
    
    // Otherwise, reset error state to trigger React re-render
    // React will automatically retry lazy loading the component
    this.setState({ hasError: false, error: null, retryCount: newRetryCount });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: this.props.compact ? 'auto' : '100vh',
            minHeight: this.props.compact ? 240 : undefined,
            padding: 3,
            textAlign: 'center',
          }}
        >
          <h2 style={{ color: '#d32f2f', marginBottom: '16px' }}>
            {this.props.title || 'Failed to load page'}
          </h2>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            {this.props.message || this.state.error?.message || 'An error occurred while loading the page'}
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            {this.props.retryLabel || 'Reload Page'}
          </button>
        </Box>
      );
    }

    return this.props.children;
  }
}
